import lscache from "lscache";

const chatBotStorageKey = "chat_bot";

interface IChatBotStorage {
    didShowAutomatically: boolean;
}

export function getChatBotStorage() {
    return lscache.get(chatBotStorageKey) as IChatBotStorage | null;
}

export function setChatBotStorage(data: IChatBotStorage) {
    lscache.set(chatBotStorageKey, data);
}
import lscache from "lscache";

const chatBotStorageKey = "chat_bot";

interface IChatBotStorage {
    didShowAutomatically: boolean;
}

export function getChatBotStorage() {
    return lscache.get(chatBotStorageKey) as IChatBotStorage | null;
}

export function setChatBotStorage(data: IChatBotStorage) {
    lscache.set(chatBotStorageKey, data);
}
